import { render, staticRenderFns } from "./editDigitalSignage.vue?vue&type=template&id=c0320bfa&scoped=true"
import script from "./editDigitalSignage.ts?vue&type=script&lang=ts&external"
export * from "./editDigitalSignage.ts?vue&type=script&lang=ts&external"
import style0 from "./editDigitalSignage.scss?vue&type=style&index=0&id=c0320bfa&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0320bfa",
  null
  
)

export default component.exports